export default "__VITE_ASSET__BtgVNDay__"